import { Component } from '@angular/core';
import { FiNotificationService } from './notification.service';

@Component({
    selector: 'fi-notifications-pull',
    template: ` <div class="ccm-notifications-pool">
          @for (noti of notifications; track noti) {
            <div class="ccm-notification">
              <ng-container *ngComponentOutlet="noti.factory; injector: noti.injector"></ng-container>
            </div>
          }
        </div>`,
    standalone: false,
})
export class FiNotificationsPullComponent {
    constructor(private notificationService: FiNotificationService) {}

    get notifications() {
        return this.notificationService.notifications;
    }
}
